import { ButtonRoot } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { cn } from '@/utils/commonUtil'
import { toggleThemeCookie } from '@/utils/cookieUtil'

import styles from './ThemeSwitcher.module.scss'

type Props = {
  className?: string
  showLabel?: boolean
  variant?: 'account'
}

const TITLE_SHORT = 'Toggle Light/Dark'
const LIGHT_MODE_SHORT = 'Light'
const DARK_MODE_SHORT = 'Dark'

const TITLE_LONG = 'Toggle Light/Dark Mode'
const LIGHT_MODE_LONG = 'Light Mode'
const DARK_MODE_LONG = 'Dark Mode'

export const ThemeSwitcher = ({ className, showLabel, variant }: Props) => (
  <ButtonRoot
    aria-label={variant === 'account' ? TITLE_SHORT : TITLE_LONG}
    className={cn(styles.container, className, { styles, variant })}
    onClick={toggleThemeCookie}
  >
    <span className={styles.graphic}>
      <span className={styles.iconLight}>
        <Icon name='sun' />
      </span>
      <span className={styles.iconDark}>
        <Icon name='moon' />
      </span>
    </span>
    {showLabel && (
      <>
        <span className={styles.labelLight}>{variant === 'account' ? LIGHT_MODE_SHORT : LIGHT_MODE_LONG}</span>
        <span className={styles.labelDark}>{variant === 'account' ? DARK_MODE_SHORT : DARK_MODE_LONG}</span>
      </>
    )}
  </ButtonRoot>
)
